export enum WebSocketEvents {
  INSTAGRAM_MESSAGE_DELETED = 'lc_ig_message_deleted',
  INSTAGRAM_MESSAGE_REACTED = 'lc_ig_message_reacted',
  INSTAGRAM_MESSAGE_UNREACTED = 'lc_ig_message_unreacted',
  FB_RN_TOPIC_OPTED_IN = 'fb_rn_topic_opted_in',
  FACEBOOK_MAIN_MENU_UNINSTALLATION_FAILED = 'facebook_main_menu_uninstallation_failed',

  NOTIFICATION_REASON_CREATED = 'one_time_notify_reason_created',
  NOTIFICATION_REASON_DELETED = 'one_time_notify_reason_deleted',
  NOTIFICATION_REASON_ARCHIVED = 'one_time_notify_reason_archived',
  NOTIFICATION_REASON_RESTORED = 'one_time_notify_reason_restored',

  INVOICE_NEXT_ACTION_REQUIRED = 'invoice_next_action_required',
  SUBSCRIPTION_UPDATED = 'subscription_updated',

  WA_CART_UPDATED = 'wa_cart_updated',
  WA_HISTORY_CONTACT_IMPORT_PROGRESS = 'wa_history_contact_import_progress',
  WA_CHANNEL_DISCONNECT_COMPLETED = 'whatsapp_channel_disconnect_completed',
  WA_PREVIEW_ACCOUNT_SUBSCRIBER_ATTACHED = 'wa_preview_account_subscriber_attached',

  LC_MESSAGE_FAILED = 'lc_message_failed',
  LC_SENT = 'lc_sent',
  LC_RECEIVED = 'lc_received',
  LC_ECHO = 'lc_echo',

  ABILITIES_UPDATED = 'abilities_updated',
  FILE_CONVERSION_SUCCEEDED = 'file_conversion_succeeded',
  FILE_CONVERSION_FAILED = 'file_conversion_failed',

  CAPI_SETTINGS_UPDATED = 'capi_settings_updated',
  LABEL_CREATED = 'label_created',
  LABEL_UPDATED = 'label_updated',
  LABEL_DELETED = 'label_deleted',
  LABEL_ASSIGNMENT_FINISHED = 'label_assignment_finished',
  LABEL_ASSIGNMENT_STARTED = 'label_assignment_started',
  KEYWORD_CREATED = 'keyword_created',
  KEYWORD_UPDATED = 'keyword_updated',
  KEYWORD_DELETED = 'keyword_deleted',

  BULK_ACTION_STATUS = 'bulk_action_status',
  SUBSCRIBERS_LIST_EXPORT_STATUS = 'subscribers_list_export_status',

  THREAD_UPDATED = 'thread_updated',
  THREAD_READ = 'thread_read',
  SUBSCRIBER_UPDATED = 'subscriber_updated',
  THREAD_MESSAGED = 'thread_messaged',
  THREAD_CLOSED = 'thread_closed',
  THREAD_OPENED = 'thread_opened',
  ASSIGN_USER_THREADS = 'assign_user_threads',
  THREAD_UNASSIGNED = 'thread_unassigned',
  THREAD_ASSIGNED = 'thread_assigned',
  THREAD_USER_READ = 'thread_user_read',
  LC_THREADS_FILTER_CHANGED = 'lc_threads_filter_changed',
  ACCOUNT_USER_ROLE_UPDATE = 'account_user_role_update',
  THREAD_BULK_ACTION_COMPLETE = 'thread_bulk_action_complete',
  THREAD_CONTROL_ERROR_RESET = 'thread_control_error_reset',
}
